<template>
    <div class="return-conditions-page">
        <div class="return-conditions-page__container">
            <div class="return-conditions-page__title">
                Условия возврата:
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        
    }
</script>

<style lang="less">
    .return-conditions-page {
        width: 100%;
        min-height: 100vh;
        display: flex;
        flex-direction: column;
        background: #fff;
    }

    .return-conditions-page__container {
        width: 100%;
        padding-left: 16px;
        padding-right: 16px;
        display: flex;
        flex-direction: column;
        padding-top: 24px;
    }

    @import '~/assets/fonts/montserrat/Montserrat-Bold.less';

    .return-conditions-page__title {
        color: #000000;
        font-size: 28px;
        font-family: 'Montserrat-Bold';
    }
</style>